
export default function MonthlyWorkHoursGraph() {
return (
      <div className="text-sm font-semibold mb-3">
        <h4>Monthly Work Hours Trend</h4>
      </div>
  );
};
